import { Component, input, Input } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationServiceService } from '../../Model/LocationMaster/location-service.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { CommonService } from '../../Model/Common/common.service';
@Component({
  selector: 'app-map-shift',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, NgSelectModule, DataTablesModule],
  templateUrl: './map-shift.component.html',
  styleUrl: './map-shift.component.scss'
})
export class MapShiftComponent {
  isDisabled: boolean = false
  @Input() ShiftTable: any[] = [];
  @Input() currentNoOfEmpinLoc!: number;
  @Input() editMode: boolean = false;
  @Input() ViewMode : boolean = false;
  @Input() AddShiftonly : boolean = false;
  Shift: any[] = [];
  ShiftTitle!: string;
  ShiftID: any = null;
  NoOfEmp!: number;
   
  Detail = {
    ESS_LocationManpowerID: '',
    SelecteType: 1,
  }
  dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: DataTables.Settings = {};
  constructor(private locationservice: LocationServiceService,
    private toast: ToastService,
    public activeModal: NgbActiveModal,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.isDisabled = true
    this.locationservice.SiteComboLoad(this.Detail).subscribe({
      next: (data) => {
        this.Shift = data.ShiftMaster;
        this.isDisabled = false
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
    // if (this.editMode != true) {
    //   this.ShiftTable = []
    // }
  }
  add() {
    if (!this.ShiftTable) {
      this.ShiftTable = [];
    }
    if (this.ShiftID == '' || this.ShiftID == null) {
      this.toast.show({ message: 'Please select a Shift', type: toastTypeEnum.warning });
      return;
    }
    console.log('on select change',this.ShiftID);
    const totalNoOfEmp = this.ShiftTable.reduce((total, row) => total + row.NoOfEmp, 0);
    const existingShiftIndex = this.ShiftTable.findIndex(shift => shift.ShiftId === this.ShiftID);
    if (existingShiftIndex == -1) {
      if (this.NoOfEmp > 0) {
        if (totalNoOfEmp + this.NoOfEmp <= this.currentNoOfEmpinLoc) {
          var shiftId = this.ShiftID;
          var shiftTitle = this.ShiftTitle;
          var noOfEmp = this.NoOfEmp;
          var shiftObject = {
            ShiftId: shiftId,
            ShiftTitle: shiftTitle,
            NoOfEmp: noOfEmp
          };
          this.ShiftTable.push(shiftObject);
          console.log('ShiftTable:', this.ShiftTable);
        }
        else {
          this.toast.show({ message: 'Total exceeds the limit. Cannot add more.', type: toastTypeEnum.warning });
        }
      }
      else {
        this.toast.show({ message: 'Cannot Add 0 Employee', type: toastTypeEnum.warning });
      }
    }
    else {
      this.toast.show({ message: 'Shift Already Exists', type: toastTypeEnum.warning });
    }
  }
  onSelectChange(type: string) {
    if (type === 'Shift') {
      const selected = this.Shift.find(shift => shift.ShiftMasterID === this.ShiftID);
      this.ShiftTitle = selected ? selected.ShiftTitle : null;
    }
  }
  deleteRow(index: number): void {
    this.ShiftTable.splice(index, 1);
  }
  onOkClick() {
    const totalNoOfEmp = this.ShiftTable.reduce((total, row) => total + row.NoOfEmp, 0);
    if (totalNoOfEmp == this.currentNoOfEmpinLoc) {
       
      this.activeModal.close(this.ShiftTable);
    }
    else {
      this.toast.show({ message: 'Please complete the No Of Employee', type: toastTypeEnum.warning });
    }
  }
  Cancel(){
    this.activeModal.close(this.ShiftTable);
  }
}
